import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0421ff46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "TinyUrl Analytics", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Upload files from TinyUrl dashboard to analyze:", -1))
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_file_uploader = _resolveComponent("base-file-uploader")!
  const _component_chart = _resolveComponent("chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_base_file_uploader, {
      id: "file-input",
      multiple: "",
      onFilesSelected: _ctx.filesChanged
    }, null, 8, ["onFilesSelected"]),
    (_ctx.apiResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_chart, {
            options: _ctx.apiResponse.clicksPerSmsChartOptions
          }, null, 8, ["options"])
        ]))
      : _createCommentVNode("", true)
  ]))
}